import React from 'react';
import BaseTab from 'react-bootstrap/Tab';
function Tab(props) {
  return /*#__PURE__*/React.createElement(BaseTab, props);
}
Tab.defaultProps = {
  notification: undefined,
  disabled: undefined,
  eventKey: undefined,
  tabClassName: undefined
};
export default Tab;